export const useSubscriptionModalOpenState = () => useState<boolean>('isSubscribeModalOpen', () => false)
